<template>
  <v-dialog v-model="dialogScan" persistent max-width="350" light>
    <v-card>
      <v-card-title class="d-flex justify-space-between ma-0">
          {{ $t('mcscanner.title')}}
          <v-icon @click="closeDialog()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-row justify="center" >
          <qrcode-stream v-if="dialogScan" :track="true" @decode="onDecode" @init="onInit"></qrcode-stream>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="closeDialog()">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  components: {
    QrcodeStream,
  },
  props: {
    dialogScan: Boolean
  },
  data: () => ({
  }),
  methods: {
    closeDialog() {
      this.$emit('update:dialogScan', false)
    },
    parseQRContent(content) {
        var s = content.substring(content.lastIndexOf('/') + 1)
        var parts = s.split(';')
        if (parts.length > 2) {
          return {cor: parts[0], pid: parts[1], nick: parts[2]}
        } else {
          return {cor: parts[0], pid: parts[0], nick: ''}
        }
    },
    onDecode(content) {
      var url = new URL(content)
      this.$router.push({path: url.pathname})
      this.closeDialog()
    },
    onInit(promise) {
      promise.then(() => {
          //console.log('Successfully initilized! Ready for scanning now!')
        })
        .catch(error => {
          if (error.name === 'NotAllowedError') {
            this.errorMessage = this.$t('mcscanner.' + error.name)
          } else if (error.name === 'NotFoundError') {
            this.errorMessage = this.$t('mcscanner.' + error.name)
          } else if (error.name === 'NotSupportedError') {
            this.errorMessage = this.$t('mcscanner.' + error.name)
          } else if (error.name === 'NotReadableError') {
            this.errorMessage = this.$t('mcscanner.' + error.name)
          } else if (error.name === 'OverconstrainedError') {
            this.errorMessage = this.$t('mcscanner.' + error.name)
          } else {
            this.errorMessage = this.$t('mcscanner.unknown')
          }
        })
    }
  }
}
</script>
